import React, { Component } from 'react';
import { EntityCrud } from '../../../components/EntityCRUD';

class BankCRUD extends Component {

    constructor() {
        super();
    }

    render() {        
        return <EntityCrud
            module="conciliation"
            entity="banks"
            permission="MANAGE_BANKS"
        />
    }
}

export default BankCRUD;